import { HttpClient } from '@angular/common/http';
import { Component, inject, type OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import * as SuperAdminOrgsGet from '../../../server/routes/super-admin/orgs/get-many';
import type { SuperAdminOrgAggregation } from '../../../server/services/org.service';
import { TitleService } from '../title.service';
import { UtilsService } from '../utils.service';

type OrgListItem = SuperAdminOrgAggregation & {
  createdAtString: string;
  updatedAtString: string;
  orgLink: string;
};

@Component({
  selector: 'app-super-admin-orgs',
  templateUrl: './super-admin-orgs.component.html',
  styleUrls: ['./super-admin-orgs.component.scss'],
  standalone: false,
})
export class SuperAdminOrgsComponent implements OnInit {
  private http = inject(HttpClient);
  private titleService = inject(TitleService);
  private utils = inject(UtilsService);

  displayedColumns: string[] = [
    'name',
    'userCount',
    'spaceCount',
    'createdAtString',
    'updatedAtString',
    '_id',
  ];

  orgs: OrgListItem[] | undefined;

  waiting = true;
  accessDenied = false;
  errorState?: 'unknownError';

  subscriptions = new Subscription();

  ngOnInit() {
    this.titleService.set('Orgs - Super admin');

    const httpSubscribe = this.http
      .get<SuperAdminOrgsGet.ResBody>('/api/super-admin/orgs')
      .subscribe({
        next: ({ orgs }) => {
          this.orgs = orgs.map((org) => {
            const item: OrgListItem = {
              ...org,
              createdAtString: new Date(org.createdAt).toLocaleDateString(),
              updatedAtString: new Date(org.updatedAt).toLocaleDateString(),
              orgLink: '/super-admin/org/' + org._id,
            };
            return item;
          });
        },
        error: (error) => {
          this.waiting = false;
          if (error.status === 0) {
            this.utils.launchOfflineNotification();
          } else if (error.status === 403) {
            this.accessDenied = true;
          } else {
            this.errorState = 'unknownError';
            console.error(error);
          }
        },
      });
    this.subscriptions.add(httpSubscribe);
  }
}
